import { render } from "./ViewReclamation.vue?vue&type=template&id=43a911a2&ts=true"
import script from "./ViewReclamation.vue?vue&type=script&lang=ts"
export * from "./ViewReclamation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__